import { intlFormat } from 'date-fns';
import { useIntl } from 'react-intl';
import { useParams } from 'wouter';

import useCategory from '../../hooks/useCategory';
import useFormat from '../../hooks/useFormat';
import useTopic from '../../hooks/useTopic';
import { useTaxonomyUrlGenerator } from '../../hooks/useUrlGenerator';
import { isMessage } from '../../lib/utils';

import { typesSections } from '../../routes';
import Metadata from './Metadata';

const hooks = {
    category: useCategory,
    topic: useTopic,
    format: useFormat,
};

interface TaxonomyMetadataProps {
    type: 'category' | 'topic' | 'format';
}

function TaxonomyMetadata({ type: taxonomyType }: TaxonomyMetadataProps) {
    const intl = useIntl();
    const { slug: slugParam, type: subTypeParam = null } = useParams<TaxonomyRouteParams>();
    const { taxonomy = null } = hooks[taxonomyType](slugParam);
    const taxonomyUrl = useTaxonomyUrlGenerator();
    const subType =
        subTypeParam !== null
            ? typesSections.find(({ id, path }) => id === subTypeParam || path === subTypeParam) ||
              null
            : null;
    const { label: subTypeLabel = null } = subType || {};
    const taxonomyTypeKey = taxonomyType.replace(/y$/, 'ie').replace(/s?$/, 's');
    const trackingVariables = {
        categories: [taxonomy],
        [taxonomyTypeKey]: [taxonomy],
    };
    if (taxonomy === null) {
        return null;
    }
    const { label, image, brand, metadata, type } = taxonomy;
    const { title, description } = metadata || {};
    return (
        <Metadata
            brand={brand}
            title={[subTypeLabel, title || label]
                .filter((item) => item !== null)
                .map((it) => (isMessage(it) ? intl.formatMessage(it) : it))
                .join(' - ')}
            description={description}
            image={image}
            url={taxonomyUrl(taxonomy)}
            pageType={type}
            trackingVariables={trackingVariables}
        />
    );
}

export default TaxonomyMetadata;
